import { Typography } from '../../../Typography';
import { Box } from '../../../Box';

/**
 * Свойства компонента {@link HelperText}
 */
interface HelperTextProps {
  /**
   * Текст для отображения.
   */
  text: string;
}

/**
 * HelperText - компонент для отображения вспомогательного текста.
 *
 * @public
 * @param text - Текст для отображения.
 * @returns Возвращает JSX-элемент представляющий компонент HelperText.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link HelperTextProps}
 */
export const HelperText = ({ text }: HelperTextProps) => {
  return (
    <Box pt="4">
      <Typography variant="caption" color="text.light.tertirary">
        {text}
      </Typography>
    </Box>
  );
};
